import React, { FC } from 'react'
import { Icon } from 'components/base-ui'
import styled from 'styled-components'
import Fonts from './Fonts'
import BounceNotification from './BounceNotification'

interface Props {
  testId?: string
  name: string
  icon: string
  iconSize?: string
  active: boolean
  inActive?: boolean
  cartQuantity?: number
  disabled?: boolean
  onClick: () => void
}

const FooterMenuItem: FC<Props> = ({
  testId,
  name,
  icon,
  iconSize,
  active,
  inActive,
  cartQuantity,
  disabled,
  onClick,
}) => {
  return (
    <MenuItem $active={active} $inActive={inActive} onClick={onClick} data-testid={testId} disabled={disabled}>
      <IconWrapper>
        <Icon name={icon} size={iconSize ? iconSize : '19px'} />
        {cartQuantity && cartQuantity !== 0 ? (
          <CartNotification data-testid="cart-quantity">
            <BounceNotification quantity={cartQuantity} />
          </CartNotification>
        ) : null}
      </IconWrapper>
      <MenuText>{name}</MenuText>
    </MenuItem>
  )
}

export default FooterMenuItem

export const MenuItem = styled.div<{ $active: boolean; $inActive?: boolean; disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 1px;
  padding-top: 4px;
  width: 100%;
  height: 44px;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.white};
  ${({ $active, theme }) =>
    $active &&
    `
    color: ${theme.colors.white};
    background-color: ${theme.colors.primary};
  `}

  ${({ $inActive }) =>
    $inActive
      ? `
    opacity: .3;
  `
      : ''}

  ${({ disabled, theme }) => disabled && `color: ${theme.colors.gray600};`}
`

export const MenuText = styled(Fonts.SmallTitleRegular)`
  font-size: 11px;
`

export const IconWrapper = styled.div`
  position: relative;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CartNotification = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin-top: -12px;
  margin-right: -20px;
  font-size: 11px;
`
